function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".isko_icon_long-arrow-up_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "isko_icon_long-arrow-up_svg__cls-1",
  d: "M6 7.5l6-6 6 6M12 2v22"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

function SvgIskoIconLongArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "isko_icon_long-arrow-up_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+LmNscy0xLC5jbHMtMntmaWxsOm5vbmU7fS5jbHMtMXtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5pc2tvPC90aXRsZT4KICA8cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjYgNy41IDEyIDEuNSAxOCA3LjUiLz4KICA8bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxMiIgeTE9IjIiIHgyPSIxMiIgeTI9IjI0Ii8+CiAgPHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KPC9zdmc+Cg==";
export { SvgIskoIconLongArrowUp as ReactComponent };